
const UtilityService = {
    getAlertName(alertName) {
        const userDetails = JSON.parse(localStorage.getItem("user-details"));
        const currentAlert = userDetails?.skuDetails?.alerts?.filter(
            (alert) => alert.alertString === alertName);
        return currentAlert[0]?.alertShortString;
    }
}

export default UtilityService;
